import { useEffect, useState } from 'react';

import FormDiscardConfirmationPanel from 'components/FormDiscardConfirmationPanel';

import type { Props, UseFormDiscardConfirmationReturn } from './types';

const useFormDiscardConfirmation = ({
    isDirty,
    onCancelClose,
    onClose,
    requestingClose
}: Props): UseFormDiscardConfirmationReturn => {
    const [showConfirmation, setShowConfirmation] = useState(false);

    useEffect(() => {
        if (requestingClose) {
            if (isDirty) {
                setShowConfirmation(true);
            } else {
                onClose?.();
            }
        }
    }, [requestingClose, isDirty, onClose]);

    const handleBackFromConfirmation = () => {
        setShowConfirmation(false);
        onCancelClose?.();
    };

    const handleDiscardConfirmation = () => {
        setShowConfirmation(false);
        onClose?.();
    };

    const confirmationPanel = showConfirmation ? (
        <FormDiscardConfirmationPanel
            onBack={handleBackFromConfirmation}
            onDiscard={handleDiscardConfirmation}
        />
    ) : null;

    return {
        confirmationPanel,
        showConfirmation
    };
};

export default useFormDiscardConfirmation;
